@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

@border: 1px solid @page-layout--border-color;

.title {
  .adelle();
  margin-right: 15px;
  font-weight: @normal;
  color: @page-layout--title--text-color;
  font-size: 20px;
}

.header {
  .adelle();
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 15px;
  min-height: 50px;
  height: 50px;
  background-color: @page-layout--header--background-color;
}

.title-section {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.view-list {
  background-color: @page-layout--view-list--background-color;
  padding-left: 15px;
  border-bottom: @border;
}

.grid {
  flex-grow: 1;
  width: 100%;
  height: calc(100% ~'-' 42px);
}

.grid-with-paging {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
